module.exports = __webpack_public_path__ + "static/12-0ef48db29c745c7e18a9a06de5509429.jpeg";